const mLogout = {
  mLogout: {
    message: 'Saliendo de la Academia...'
  }
}

export default mLogout
